import { DOCUMENT } from "@angular/common";
import { inject, Injectable } from "@angular/core";

type Theme = "DEFAULT" | "INTERNAL_VIEW";

@Injectable({
	providedIn: "root",
})
export class ThemeService {
	private document = inject(DOCUMENT);

	switchTheme(theme: Theme): void {
		switch (theme) {
			case "DEFAULT":
				this.document.body.classList.remove("theme-purple");
				break;
			case "INTERNAL_VIEW":
				this.document.body.classList.add("theme-purple");
				break;
		}
	}
}
